export enum HealthEventSortOrderAttrType {
  HEALTH_EVENT_SORT_ORDER = 'healthEventSortOrder',
}
